var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({},on),[_c('v-btn',_vm._g({attrs:{"text":"","x-small":"","disabled":!_vm.fileId},on:{"click":_vm.previewFile}},on),[_c('v-icon',[_vm._v("mdi-file-eye-outline")])],1)],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }